import React from 'react';

import {
  ListButton,
  TopToolbar,
} from 'react-admin';

import CancelRepairAction from './CancelRepairAction';
import RefundRepairAction from './RefundRepairAction';

const RepairEditActions = () => (
  // Overrides the default RA behavior of offering a "Show" option
  // We always want to display the "Edit" view for Under Review statues
  <TopToolbar>
    <CancelRepairAction />
    <RefundRepairAction />
    <ListButton />
  </TopToolbar >
);

export default RepairEditActions;
